import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const BatteryAndroidFrameBoltOutlined: React.FC<React.PropsWithChildren<SvgIconProps>> = (props) => (
  <SvgIcon width="19" height="10" viewBox="0 0 19 10" fill="none" {...props}>
    <path
      d="M2.5 10C1.80556 10 1.21528 9.75694 0.729167 9.27083C0.243056 8.78472 0 8.19444 0 7.5V2.5C0 1.80556 0.243056 1.21528 0.729167 0.729167C1.21528 0.243056 1.80556 0 2.5 0H14.2083L12.875 1.66667H2.5C2.26389 1.66667 2.06597 1.74653 1.90625 1.90625C1.74653 2.06597 1.66667 2.26389 1.66667 2.5V7.5C1.66667 7.73611 1.74653 7.93403 1.90625 8.09375C2.06597 8.25347 2.26389 8.33333 2.5 8.33333H12.3542L12.0417 10H2.5ZM13.8958 9.16667L14.4792 5.83333H11.6667L15.6667 0.833333H16.1042L15.5208 4.16667H18.3333L14.3333 9.16667H13.8958ZM2.5 7.5V2.5H12.2083L8.20833 7.5H2.5Z"
      fill="#66BB6A"
    />
  </SvgIcon>
);

export default BatteryAndroidFrameBoltOutlined;
